export enum InvoiceDocumentType {
  INVOICE = 'invoice',
  RECEIPT = 'receipt'
}
